import React from "react";
import { Waypoint } from "react-waypoint";
import classNames from "classnames";
import { brandPropTypes } from "app/utils/propTypes";
import { pushTagOnGridViewActive, pushTagOnListViewActive } from "app/utils/analytics";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import PropTypes from "prop-types";
import "./listing.scss";
import { IS_DEFAULT_LISTING_VIEW_LIST } from "src/@brand/appConstants";
import ListingHeaderContainer from "app/pages/Listing/ListingHeader/ListingHeaderContainer";
import { BRANDS } from "app/constants";
import { AsideProductFiltersContainer } from "app/pages/.shared/AsidePanel/AsideProductFilters/AsideProductFiltersContainer";
import { AsideProductFiltersMenu } from "@brand/AsidePanel/AsideProductFilters/AsideProductFiltersMenu";
import ProductsFilterContainer from "@brand/ProductsFilter/ProductsFilterContainer";
import { StickyContainer } from "react-sticky";
import { scrollToElement } from "app/utils/scroller";
import { forceCheck } from "react-lazyload";
import CookiePolicyFooterContainer from "app/pages/.shared/CookiePolicyFooter/CookiePolicyFooterContainer";
import ListingContentContainer from "app/pages/Listing/ListingContent/ListingContentContainer";
import IconGoToTopArrow from "app/pages/.shared/static/icons/IconGoToTopArrow";
import { PushNotificationContainer } from "app/pages/.shared/PushNotification/PushNotificationContainer";
import get from "lodash/get";
import MoreProductBanner from "app/pages/Listing/components/MoreProductBanner";

class Listing extends React.Component {
	constructor() {
		super();
		this.state = {
			listViewDisplay: IS_DEFAULT_LISTING_VIEW_LIST,
			showScrollTopButton: false,
		};
		this.asideProductFiltersMenuComponent = this.asideProductFiltersMenuComponent.bind(this);
		this.toogleListView = this.toogleListView.bind(this);
		this.toogleCardView = this.toogleCardView.bind(this);
		this.showScrollTopButton = this.showScrollTopButton.bind(this);
		this.hideScrollTopButton = this.hideScrollTopButton.bind(this);
		this.scrollToListingHeader = this.scrollToListingHeader.bind(this);
		this.listingHeaderRef = React.createRef();
	}

	asideProductFiltersMenuComponent(props) {
		const brand = this.props.brand;
		return brand === BRANDS.AF || brand === BRANDS.TO || brand === BRANDS.UG ? (
			<AsideProductFiltersMenu
				scrollToListingHeader={this.scrollToListingHeader}
				{...props}
			/>
		) : (
			false
		);
	}

	componentWillUpdate() {
		// force l'affichage des images des produits sur mobile lorsqu'un filtre est actif
		forceCheck();
	}

	scrollToListingHeader() {
		scrollToElement(this.listingHeaderRef.current, 0, true);
	}

	toogleCardView() {
		this.setState({
			listViewDisplay: false,
		});
		pushTagOnGridViewActive();
	}

	toogleListView() {
		this.setState({
			listViewDisplay: true,
		});
		pushTagOnListViewActive();
	}

	showScrollTopButton({ previousPosition, currentPosition }) {
		if (previousPosition === Waypoint.above && currentPosition === Waypoint.inside) {
			this.setState({ showScrollTopButton: false });
		}
	}

	hideScrollTopButton({ previousPosition, currentPosition }) {
		if (previousPosition === Waypoint.inside && currentPosition === Waypoint.above) {
			this.setState({ showScrollTopButton: true });
		}
	}

	handleScrollToTopClick() {
		window.scrollTo(0, 0);
	}

	render() {
		const { idSpotlight, prefetchedPhotos, displayProductsCount, marketing } = this.props;

		const scrollTopButtonClass = classNames({
			"scroll-top-button": true,
			"scroll-top-button--visible": this.state.showScrollTopButton,
		});

		const waypointScrollableAncestor = typeof window !== "undefined" ? window : undefined;

		return (
			<StickyContainer>
				<AsideProductFiltersContainer>
					<ProductsFilterContainer
						asideFilterMenu={false}
						renderComponent={this.asideProductFiltersMenuComponent}
					/>
				</AsideProductFiltersContainer>

				<div className="listing">
					<HeadMetadata prefetchRessources={prefetchedPhotos} page="listing" />
					<ListingHeaderContainer
						idSpotlight={idSpotlight}
						isListViewDisplay={this.state.listViewDisplay}
						toogleCardView={this.toogleCardView}
						toogleListView={this.toogleListView}
						scrollToListingHeader={this.scrollToListingHeader}
						listingHeaderRef={this.listingHeaderRef}
						displayProductsCount={displayProductsCount}
					/>

					<Waypoint
						topOffset="-2500px"
						scrollableAncestor={waypointScrollableAncestor}
						onEnter={this.showScrollTopButton}
						onLeave={this.hideScrollTopButton}
					/>

					<ListingContentContainer
						displayProductsCount={displayProductsCount}
						spotlightUri={idSpotlight}
						isListViewDisplay={this.state.listViewDisplay}
					/>

					{get(marketing, "moreProductsBanner") && (
						<div className="listing__more-product-banner">
							<div className="listing__more-product-banner__container">
								<MoreProductBanner
									desktopSrc={get(
										marketing,
										"moreProductsBanner.images.listDesktop"
									)}
									desktopThumbnail={get(
										marketing,
										"moreProductsBanner.images.listDesktopThumbnail"
									)}
									mobileSrc={get(
										marketing,
										"moreProductsBanner.images.listMobile"
									)}
									mobileThumbnail={get(
										marketing,
										"moreProductsBanner.images.listMobileThumbnail"
									)}
									message={get(marketing, "moreProductsBanner.introduction")}
									ctaButtonText={get(
										marketing,
										"moreProductsBanner.displayOptions.labelCta"
									)}
									ctaButtonBackgroundColor={get(
										marketing,
										"moreProductsBanner.displayOptions.bgColorCta"
									)}
									ctaButtonColor={get(
										marketing,
										"moreProductsBanner.displayOptions.txtColorCta"
									)}
									redirectUrl={get(
										marketing,
										"moreProductsBanner.displayOptions.redirectUrl"
									)}
								/>
							</div>
						</div>
					)}

					<span className={scrollTopButtonClass} onClick={this.handleScrollToTopClick}>
						<IconGoToTopArrow width={50} height={50} />
					</span>

					<CookiePolicyFooterContainer />
				</div>
				<PushNotificationContainer />
			</StickyContainer>
		);
	}
}

Listing.propTypes = {
	brand: brandPropTypes,
	prefetchedPhotos: PropTypes.arrayOf(PropTypes.string),
	idSpotlight: PropTypes.string,
	marketing: PropTypes.object,
	displayProductsCount: PropTypes.bool,
};

export default Listing;
